;(function () {
  'use strict'

  if (window.customClarityConsentReady) return
  window.customClarityConsentReady = true

  const projectId = 'yhkauqd82h'
  let clarityLoading = false

  function consentState(customerPrivacy) {
    return {
      ad_Storage: customerPrivacy.marketingAllowed() ? 'granted' : 'denied',
      analytics_Storage: customerPrivacy.analyticsProcessingAllowed() ? 'granted' : 'denied',
    }
  }

  function passConsent(customerPrivacy) {
    if (typeof window.clarity !== 'function') return
    window.clarity('consentv2', consentState(customerPrivacy))
  }

  function loadClarity(customerPrivacy) {
    if (!customerPrivacy.analyticsProcessingAllowed()) return
    if (clarityLoading) {
      passConsent(customerPrivacy)
      return
    }

    const existingScript = document.querySelector('[data-clarity-consent]')
    if (existingScript) {
      passConsent(customerPrivacy)
      return
    }

    clarityLoading = true
    window.clarity =
      window.clarity ||
      function () {
        ;(window.clarity.q = window.clarity.q || []).push(arguments)
      }

    passConsent(customerPrivacy)

    const script = document.createElement('script')
    script.async = true
    script.src = `https://www.clarity.ms/tag/${projectId}`
    script.dataset.clarityConsent = ''
    script.onerror = () => {
      clarityLoading = false
      script.remove()
    }
    document.head.appendChild(script)
  }

  function syncClarity(customerPrivacy) {
    if (customerPrivacy.analyticsProcessingAllowed()) {
      loadClarity(customerPrivacy)
    } else {
      passConsent(customerPrivacy)
    }
  }

  function initializeClarityConsent() {
    if (!window.Shopify?.loadFeatures) return

    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (error || !window.Shopify.customerPrivacy) return

      const customerPrivacy = window.Shopify.customerPrivacy
      const syncConsent = () => syncClarity(customerPrivacy)

      document.addEventListener('visitorConsentCollected', syncConsent)
      syncConsent()
    })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeClarityConsent, { once: true })
  } else {
    initializeClarityConsent()
  }
})()
